module.exports = __webpack_public_path__ + "img/congrets.facf87db.png";